<script>

    import { AppBar, Button, Icon, TextField, Dialog, ProgressCircular, List, ListItem, Chip, Row, Col, Select, Overlay, ClickOutside, Snackbar, DataTable, DataTableHead, DataTableRow, DataTableCell, DataTableBody, Menu, Subheader, ListItemGroup, Textarea } from 'svelte-materialify';
    import { mdiArrowLeft, mdiEyeOff, mdiEye, mdiClose, mdiDelete, mdiCamera, mdiPencil, mdiLogout, mdiDotsHorizontalCircle, mdiPlus, mdiFloppy, mdiDotsVertical, mdiDownload, mdiFilterVariant, mdiSend } from '@mdi/js';
    import { createEventDispatcher, onMount } from 'svelte';
    import {Html5Qrcode} from "html5-qrcode"
    import moment from 'moment';

    const dispatch = createEventDispatcher();

    export let server;

    // Servers
    const server_utenti = `https://${server}.sensesquare.eu:5002/`;
    const nominatim = "https://nominatim.sensesquare.eu/nominatim/"; 

    // Email rules
    const emailRules = [
        (v) => !!v || 'Required',
        (v) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || 'Invalid e-mail.';
        },
    ];

    // Password rules
    const passwordRules = [
        v => !!v || 'Required',
        v => v.length >= 8 || "Deve essere lunga almeno 8 caratteri",
        v => {
            let pattern = /[A-Z]{1,}/gm;
            return pattern.test(v) || "Almeno una maiuscola";
        },
        v => {
            let pattern = /[a-z]{1,}/gm;
            return pattern.test(v) || "Almeno una minuscola";
        },
        v => {
            let pattern = /[0-9]{1,}/gm;
            return pattern.test(v) || "Almeno un numero";
        },
        v => {
            let pattern = /\#{1,}|\@{1,}|\${1,}|\!{1,}|\%{1,}|\*{1,}|\?{1,}|\&{1,}|\.{1,}|\+{1,}|\-{1,}|\={1,}/gm;
            return pattern.test(v) || "Almeno un carattere speciale #, @, $, !, %, *, ?, &, ., +, -, =";
        }
    ];

    // Inquinanti
    const tipologiaAdds = [
        {name: "Guidato", value: "guided"},
        {name: "Custom", value: "custom"}
    ];
    
    const allInquinanti = [
        {name: "C7H8", value: "c7h8"},
        {name: "C6h6", value: "c6h6"},
        {name: "VOC", value: "voc"},
        {name: "NO2", value: "no2"},
        {name: "SO2", value: "so2"}
    ];

    const guidedInquinanti = [
        {name: "NO2", value: "no2"},
        {name: "SO2", value: "so2"}
    ];

    // Password, email and others
    let email = "";
    let password = "";
    let showPassword = false;
    let stateLogin = "loading"

    // Search bar
    let query = "";
    let searchBarShadow = "elevation-0"

    // Elenco provette
    let elenco_provette = [];
    let pagina_provette = 0;
    let pagine_totali = 1;
    let isDownloadingList = false;

    // Filtri elenco
    let progettoSelected = null;
    let statusSelected = 0;
    let showPopupProgetti = false;
    let queryProgetto = "";

    // Page provetta
    let id_provetta = null;
    let dataProvetta = null;
    let somethingChanged = false;
    let updatePage = 0;
    let shadowPageFlat = true;

    // Add concentrazione
    let addConcentrazione = false;
    let tipologiaAdd = "guided";
    let inquinante = null;
    let value = "";
    let curve = [];
    let curva = null;
    let assorbanza = "";
    let volumeFinale = "";
    let volumePrelievo = "";
    let valueK = "";
    let volumeEstrazione = "";
    let concentrazioneInCuvetta = "";

    // Curva creator
    let showCurvaCreator = false
    let newCurvaName = "";
    let punti = [["", ""]];
    let saveCurvaReady = false;

    // Snackbar
    let snackbarActive = false;
    let snackbarMessage = "";

    // Scan
    let showScan = false;
    let html5QrCode;
    let showErrorBox = false;

    let user = null;


    onMount(() => {

        console.log("CIAO");

        let saved_user = localStorage.getItem("user-info");

        if(!saved_user){
            console.log("CIAO");
            stateLogin = "login";
            return;
        }

        saved_user = JSON.parse(saved_user);

        let p = new FormData();
        p.append("token", saved_user.token);

        checkToken(p)
        .then(() => {
            user = saved_user;
        })
        .catch(e => {
            stateLogin = "login";
        })

    });

    // check token
    function checkToken(params){
      return new Promise((resolve, reject) => {
        fetch(server_utenti + "check_token", {
          method: "POST",
          body: params
        })
        .then(response => response.json())
        .then(result => {
          if(result.response_code === 200)
            resolve(result.result);
          else
            reject(result);
        })
        .catch(e => reject(e));
      });
    }

    // Login
    async function login() {
        try {
            
            // Verifica email e password
            if(email && password && verifyPassword()){

                stateLogin = "loading";

                // Preparazione dei parametri
                let params = new FormData();
                params.append("email", email);
                params.append("password", password);
                params.append("domain", "citisense.sensesquare.eu");

                // Richiesta di login
                let response = await fetch(server_utenti + "login", {
                    method: "POST",
                    body: params
                });

                // Conversione in json
                let user_info = await response.json();

                console.log(user_info);

                // Verifica response del server
                if(user_info.response_code === 200){
                    localStorage.setItem("user-info", JSON.stringify(user_info.result));
                    user = user_info.result;
                        
                    return;
                }else {
                    stateLogin = user_info.message;
                }

            }
        } catch (e) {
            console.log(e);
            stateLogin = e;
        }
    }

    function verifyPassword() {
        let isOk = true;
        passwordRules.forEach(check => {
            if(check(password) !== true)
                isOk = false;
        });
        return isOk;
    }

    async function elencoProvette(progetto=undefined, status=undefined) {

        // Reset elenco
        if(progetto !== undefined || status !== undefined){
            elenco_provette = [];
            pagina_provette = 0;
            pagine_totali = 1;
            isDownloadingList = false;
        }
        
        if(isDownloadingList || pagina_provette >= pagine_totali)
            return;

        isDownloadingList = true;

        pagina_provette += 1;
        
        try {
            
            let p = new FormData();
            p.append("token", user.token);
            p.append("pagina", pagina_provette);
            p.append("filtro", statusSelected);

            if(progettoSelected && typeof(progettoSelected) === "string")
                p.append("progetto", progettoSelected);

            let data = await (await fetch(server_utenti + "elenco_provette", {method: "POST", body: p})).json();
            
            isDownloadingList = false;

            if(data.response_code === 200){
                pagine_totali = data.pagine_totali;
                elenco_provette = [...elenco_provette, ...data.result];
                return elenco_provette;
            }

            throw data.message;

        } catch (error) {
            isDownloadingList = false;
            console.log(error);
            throw "Ops! Sembra esserci un problema";
        }

    }

    function updateShadow(e) {
        
        if(e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight){
            elencoProvette();
        }
        
        if(e.target.scrollTop > 0)
            searchBarShadow = "elevation-1";
        else
            searchBarShadow = "elevation-0";
    }

    function getStateColor(state) {
        switch (state) {
            case "Nessuno":
                return "red darken-1 white-text"
            case "Aperta":
                return "yellow darken-3 white-text"
            case "Chiusa":
                return "lime darken-2 white-text"
            default:
                return "green darken-1 white-text";
        }
    }

    async function searchProvetta(q, progetto=undefined, status=undefined) {
        
        try {
            
            let p = new FormData();
            p.append("token", user.token);
            p.append("id_provetta", q);

            if(status && typeof(status) === "number")
                p.append("filtro", status);

            if(progetto && typeof(progetto) === "string")
                p.append("progetto", progetto);

            let data = await (await fetch(server_utenti + "suggerimenti_provette", {method: "POST", body: p})).json();
            
            if(data.response_code === 200)
                return data.result;

            throw data.message;

        } catch (error) {
            console.log(error);
            throw "Ops! Sembra esserci un problema";
        }

    }

    async function informazioniProvetta(id_provetta) {

        try {
            
            let p = new FormData();
            p.append("token", user.token);
            p.append("id_provetta", id_provetta);
            let data = await (await fetch(server_utenti + "informazioni_provetta", {method: "POST", body: p})).json();
            
            if(data.response_code === 200){
                dataProvetta = data.result;
                return;
            }

            throw data.message;

        } catch (error) {
            console.log(error);
            throw "Ops! Sembra esserci un problema";
        }

    }

    async function elencoCurve(inquinante, progetto) {

        curve = [];
        curva = null;

        try {
            
            let p = new FormData();
            p.append("token", user.token);
            p.append("inquinante", inquinante);
            p.append("progetto", progetto);
            let data = await (await fetch(server_utenti + "elenco_curve_calibrazione", {method: "POST", body: p})).json();
            
            if(data.response_code === 200){
                curve = data.result;

                if(curve.length > 0)
                    curva = curve[0];

                return;
            }else if(data.response_code === 400){
                curve = [];
                return;
            }
                
            showSnackbar(data.message);

            throw data.message;

        } catch (error) {
            console.log(error);
            showSnackbar("Ops! sembra esserci un problema");
            throw "Ops! Sembra esserci un problema";
        }

    }

    function getDateString(date) {
        return moment.parseZone(date).toDate().toLocaleString();
    }

    function deleteCoefficiente(k) {
        
        if(!dataProvetta)
            return;

        if(!dataProvetta?.concentrazione)
            return;

        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", id_provetta);
        p.append("inquinante", k);

        fetch(server_utenti + "elimina_concentrazione_provetta", {
            method: "POST",
            body: p
        })
        .then(response => response.json())
        .then(result => {

            if(result.response_code === 200){

                somethingChanged = true;

                if(Object.keys(dataProvetta.concentrazione).length > 1)
                    delete dataProvetta.concentrazione[k];
                else
                    delete dataProvetta.concentrazione;

                dataProvetta = dataProvetta;

                // Refresh page
                updatePage += 1;

            }

            showSnackbar(result.message);

        })
        .catch(e => {
            showSnackbar("Ops! Sembra esserci un problema")
            console.log(e);
        })

    }

    function resetVariables() {
        // Page provetta
        id_provetta = null;
        dataProvetta = null;
        updatePage = 0;
        shadowPageFlat = true;

        if(somethingChanged){
            pagina_provette = -1;
            elenco_provette = [];
            elencoProvette();
            somethingChanged = false;
        }

        resetVariablesAddConcentrazione();
    }

    function resetVariablesAddConcentrazione() {
        addConcentrazione = false;
        tipologiaAdd = "guided";
        inquinante = null;
        value = "";
        curva = null;
        curve = [];
        assorbanza = "";
        volumeFinale = "";
        volumePrelievo = "";
        valueK = "";
        volumeEstrazione = "";
        concentrazioneInCuvetta = "";

        resetVariablesCurvaCreator();
    }

    function resetVariablesCurvaCreator(params) {
        // Curva creator
        showCurvaCreator = false
        newCurvaName = "";
        punti = [["", ""]];
        saveCurvaReady = false;
    }

    function showSnackbar(message) {
        snackbarMessage = message;
        snackbarActive = true;
    }

    function applyConcentrazione(_value=value) {

        if(!dataProvetta)
            return;

        if(!_value || _value === "...")
            return;

        if(!inquinante)
            return;

        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", id_provetta);
        p.append("inquinante", inquinante);
        p.append("concentrazione", _value);

        fetch(server_utenti + "aggiorna_concentrazione_provetta", {
            method: "POST",
            body: p
        })
        .then(response => response.json())
        .then(result => {

            if(result.response_code === 200){

                somethingChanged = true;

                if(!dataProvetta.hasOwnProperty("concentrazione"))
                    dataProvetta.concentrazione = {};

                dataProvetta.concentrazione[inquinante] = _value;
                resetVariablesAddConcentrazione();

                // Refresh page
                updatePage += 1;

            }

            showSnackbar(result.message);

        })
        .catch(e => {
            showSnackbar("Ops! Sembra esserci un problema")
            console.log(e);
        })

    }

    function startCamera() {

        if(!html5QrCode)
            html5QrCode = new Html5Qrcode("scan-area-admin")

        console.log("CAMERA START");

        html5QrCode.start(
        { facingMode: "environment" }, 
        {
            fps: 24,
            qrbox: { width: 300, height: 80, } 
        },
        (decodedText, decodedResult) => {
            checkCode(decodedText);
        })
        .then(() => {
        })
        .catch((err) => {
            console.log(err);
            showErrorBox = true;
        });
    }

    function checkCode(code) {

        if(!(/[A-Z : a-z]{2}-[A-Z : a-z : 0-9]{5,}/gm.test(code)))
            return;

        id_provetta = code;

        stopCamera();

    }

    function stopCamera() {

        showScan = false;

        if(!html5QrCode)
            return;
        
        html5QrCode.stop().then((ignore) => {
            // QR Code scanning is stopped.
        }).catch((err) => {
            // Stop failed, handle it.
        });
    }

    async function getNominatim(route, params={}, options={}, getResponse=false){
      //let p = "key=pk.04c2467ae7df5d59f25bbedc5a2872d1&";
      let p = ""
      Object.entries(params).forEach(([key, val]) => {
        p += `${key}=${val}&`;
      })
      p = p.substring(0, p.length);
      if(getResponse)
        return await fetch(`${nominatim}/${route}.php?${p}`, options);
      return await (await fetch(`${nominatim}/${route}.php?${p}`, options)).json()
    }

    async function getAddress(pos) {
        
        try {
            
            pos = JSON.parse(pos);
            
            let result = await getNominatim("reverse", {
                lat: pos.lat,
                lon: pos.lng,
                format: "jsonv2"
            });

            let res = result?.display_name || "Errore con il geodecoder";

            return res;

        } catch (error) {
            
            console.log(error);
            return "Errore con il geodecoder";

        }

    }

    function copyProvetta() {

        let text = "ID provetta: " + id_provetta;

        if(dataProvetta.hasOwnProperty("email"))
            text += "\nEmail: " + dataProvetta.email;

        navigator.clipboard.writeText(text).then(function() {
            showSnackbar("Provetta " + id_provetta + " copiata con successo!");
        }, function() {
            showSnackbar("Impossibile eseguire l'operazione di copia")
        });

    }

    function updateCurva() {
        
        let lastPoint = punti[punti.length-1];

        if(lastPoint[0] && lastPoint[1])
            punti = [...punti, ["", ""]];

        if(typeof(showCurvaCreator) !== "string" && newCurvaName === ""){
            saveCurvaReady = false;
            return;
        }

        if(punti.length <= 2){
            saveCurvaReady = false;
            return;
        }

        let isReady = true;
        punti.forEach((p, i) => {
            if(isReady && i !== punti.length-1){
                if(!p[0] || !p[1])
                    isReady = false;
            }
        })

        saveCurvaReady = isReady;

    }

    function saveCurva(progetto) {

        if(!saveCurvaReady) {
            showSnackbar("Compila tutti i campi");
            return;
        }

        // Prepare curva
        let curvaElaborated = { x: [], y: [] };
        punti.forEach((p,i) => {
            if(i !== punti.length-1){
                curvaElaborated.x.push(p[0]);
                curvaElaborated.y.push(p[1]);
            }
        });

        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", id_provetta);
        p.append("inquinante", inquinante);
        p.append("progetto", progetto);
        p.append("curva", JSON.stringify(curvaElaborated));

        let nome_curva = newCurvaName;
        if(typeof(showCurvaCreator) === "string")
            nome_curva = showCurvaCreator;
            
        p.append("nome_curva", nome_curva);

        fetch(server_utenti + "inserisci_curva_calibrazione", {
            method: "POST",
            body: p
        })
        .then(response => response.json())
        .then(result => {

            if(result.response_code === 200){

                curve.push(nome_curva);
                curva = nome_curva;
                
                resetVariablesCurvaCreator();

            }

            showSnackbar(result.message);

        })
        .catch(e => {
            showSnackbar("Ops! Sembra esserci un problema")
            console.log(e);
        })

    }

    function deleteCurva() {
        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", id_provetta);
        p.append("inquinante", inquinante);
        p.append("nome_curva", showCurvaCreator);

        fetch(server_utenti + "elimina_curva_calibrazione", {
            method: "POST",
            body: p
        })
        .then(response => response.json())
        .then(result => {

            if(result.response_code === 200){

                curva = null;
                curve = curve.filter(n => n !== showCurvaCreator);
                console.log(curve);
                
                resetVariablesCurvaCreator();

            }

            showSnackbar(result.message);

        })
        .catch(e => {
            showSnackbar("Ops! Sembra esserci un problema")
            console.log(e);
        })
    }

    async function getPunti(progetto) {

        if(typeof(showCurvaCreator) !== "string")
            return;

        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", id_provetta);
        p.append("inquinante", inquinante);
        p.append("progetto", progetto);
        p.append("nome_curva", showCurvaCreator);

        try {

            let result = await (await fetch(server_utenti + "informazioni_curva_calibrazione", {
                method: "POST",
                body: p
            })).json();

            if(result.response_code === 200){

                let new_punti = [];

                for(let i=0; i<result.result.x.length; i++)
                    new_punti.push([result.result.x[i], result.result.y[i]]);

                punti = [...new_punti, ["", ""]];

            }else {

                showSnackbar(result.message);

            }
            
        } catch (e) {
         
            showSnackbar("Ops! Sembra esserci un problema")
            console.log(e);
            
        }

    }

    async function getConcentrazioneInCuvetta(assorbanza, progetto) {

        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", id_provetta);
        p.append("inquinante", inquinante);
        p.append("nome_curva", curva);
        p.append("progetto", progetto);
        p.append("assorbanza", assorbanza);

        try {

            let result = await (await fetch(server_utenti + "interpolazione", {
                method: "POST",
                body: p
            })).json();

            if(result.response_code === 200){

                concentrazioneInCuvetta = result.result;

            }

            showSnackbar(result.message);
            
        } catch (e) {
        
            showSnackbar("Ops! Sembra esserci un problema")
            console.log(e);
            
        }

    }

    function getOutputIntermedio(outc, volf, volp) {
        
        if(!outc || !volf || !volp)
            return "...";

        try {
            
            return (parseFloat(concentrazioneInCuvetta) * (parseFloat(volumeFinale)/parseFloat(volumePrelievo))).toFixed(2);

        } catch (error) {
            
            return "...";

        }

    }

    function getOutputInUg(vole, outc, volf, volp){

        if(!vole || !outc || !volf || !volp)
            return "...";

        let outIntermedio = getOutputIntermedio(outc, volf, volp);

        if(outIntermedio === "...")
            return "...";

        try {
            
            return (parseFloat(vole) * outIntermedio).toFixed(2);

        } catch (error) {
            
            return "...";

        }

    }

    function getConcentrazioneInAria(valueK, vole, outc, volf, volp) {
        
        if(!valueK || !vole || !outc || !volf || !volp || !dataProvetta.hasOwnProperty("tempo_apertura"))
            return "...";

        let outInUg = getOutputInUg(vole, outc, volf, volp);

        if(outInUg === "...")
            return "...";

        try {

            return ((parseFloat(valueK) * outInUg) / parseFloat(dataProvetta.tempo_apertura)).toFixed(2);

        } catch (error) {
            
            return "...";

        }

    }

    function downloadList() {
        window.open(`${server_utenti}file_provette?token=${user.token}&formato=xlsx`);
        showSnackbar("Download avviato");
    }

    // Scarica elenco progetti
    async function elencoProgetti(query="", elementi=null) {

        try {
            
            let p = new FormData();
            p.append("token", user.token);

            if(query !== "")
                p.append("query", query);

            if(elementi && typeof(elementi) === "number")
                p.append("elementi", 100);

            let data = await (await fetch(server_utenti + "elenco_progetti_citisense", {method: "POST", body: p})).json();
            
            if(data.response_code === 200){
                return data;
            }
                
            throw data.message;

        } catch (error) {
            console.log(error);
            showSnackbar("Ops! sembra esserci un problema");
            throw "Ops! Sembra esserci un problema";
        }

    }

    // Programma invio notifica
    function programmaNotifica(_id_provetta) {

        if(!_id_provetta || typeof(_id_provetta) !== "string")
            return;

        let p = new FormData();
        p.append("token", user.token);
        p.append("id_provetta", _id_provetta);

        fetch(server_utenti + "programma_notifica_provetta", {method: "POST", body: p})
        .then(response => response.json())
        .then(result => {

            showSnackbar(result.message);

            if(result.response_code === 200){
                console.log("CHIUDI PAGINA");
                id_provetta = null;
                elencoProvette(progettoSelected, statusSelected);
            }

        })
        .catch(e => {

            showSnackbar("Ops! Sembra esserci un problema");

        });

    }

    // Show shadow on scroll, page
    function showShadowPage(e) {

        if(e.target.scrollTop === 0)
            shadowPageFlat = true;
        else
            shadowPageFlat = false;

    }

</script>

<main class="green">

    <!-- Admin page content -->
    {#if user !== null}
    
        <AppBar flat class="green" style="flex: 0">
            <span slot="icon">
                <Button icon on:click={() => dispatch("close")}>
                    <Icon class="white-text" path={mdiArrowLeft} />
                </Button>
            </span>
            <span slot="title" class="white-text">
                Area riservata {server === "beta" ? "BETA" : ""}
            </span>
            <span style="flex-grow: 1;"></span>
            <Menu nudgeX={-180} index={2002}>
                <div slot="activator">
                  <Button icon class="white-text">
                      <Icon path={mdiDotsVertical} />
                  </Button>
                </div>
                <List dense style="width: 200px">
                    <ListItem on:click={downloadList}>
                        Download
                        <span slot="append">
                            <Icon path={mdiDownload} />
                        </span>
                    </ListItem>
                    <ListItem on:click={() => {
                        email = "";
                        password = "";
                        stateLogin = "login";
                        user = null;
                        localStorage.clear();
                    }}>
                        Logout
                        <span slot="append">
                            <Icon path={mdiLogout} />
                        </span>
                    </ListItem>
                </List>
            </Menu>
        </AppBar>

        <div class="content-admin d-flex justify-center">
            <div class="content white rounded elevation-1" on:scroll={updateShadow}>

                <div class="search-bar {query.length > 0 ? "green lighten-4" : "white"} pt-3 pl-3 pb-1 {searchBarShadow}">

                    <!-- AppBar -->
                    <div class="d-flex">

                        <div style="flex: 1">
                            <TextField color="{query.length > 0 ? "black" : "green"}" filled bind:value={query}>
                                Cerca provetta
                                <div slot="append">
                                    {#if !showErrorBox}
                                        <Button icon on:click={() => showScan = true}>
                                            <Icon path={mdiCamera} />
                                        </Button>
                                    {/if}
                                </div>
                            </TextField>
                        </div>

                        <div class="d-flex align-center justify-center pl-2 pr-2">

                            <Menu nudgeX={-80}>
                                <div slot="activator">
                                    <Button fab depressed size="small" class="{statusSelected !== 0 ? "green white-text" : "white"}">
                                        <Icon path={mdiFilterVariant} />
                                    </Button>
                                </div>
                                <ListItemGroup dense value={statusSelected} activeClass="green lighten-5 green-text text-darken-4">
                                    <ListItem value={0} on:click={() => statusSelected = 0}>
                                        Tutte
                                    </ListItem>
                                    <ListItem value={1} on:click={() => statusSelected = 1}>
                                        Aperte
                                    </ListItem>
                                    <ListItem value={2} on:click={() => statusSelected = 2}>
                                        Chiuse
                                    </ListItem>
                                    <ListItem value={3} on:click={() => statusSelected = 3}>
                                        Analizzate
                                    </ListItem>
                                    <ListItem value={4} on:click={() => statusSelected = 4}>
                                        Da notificare
                                    </ListItem>
                                    <ListItem value={5} on:click={() => statusSelected = 5}>
                                        Notificate
                                    </ListItem>
                                </ListItemGroup>
                            </Menu>

                        </div>

                    </div>

                    {#if query.length > 0}
                    
                        {#await searchProvetta(query, progettoSelected, statusSelected)}

                            <div class="d-flex align-center justify-center pa-3">
                                <ProgressCircular indeterminate color="green" />
                            </div>
                            
                        {:then result}

                            {#if result.length > 0}
                            
                                <List style="width: 100%" dense>
                                
                                    {#each result as p}
                                        <ListItem on:click={() => id_provetta = p.id_provetta}>
                                            {p.id_provetta}
                                            <span slot="subtitle">
                                                {p?.progetto ? p?.progetto : ""}
                                            </span>
                                            <div slot="append">
                                                <Chip size="small" class={getStateColor(p.stato)}>
                                                    {p.stato}
                                                </Chip>
                                            </div>
                                        </ListItem>
                                    {/each}
                
                                </List>

                            {:else}

                                <div class="text-center pa-3">
                                    Non ci sono provette
                                </div>

                            {/if}
                        
                        {:catch e}

                            <div class="text-center pa-3">
                                {e}
                            </div>
                            
                        {/await}

                    {/if}

                </div>

                <!-- Elenco parziale progetti -->
                <div class="elenco-parziale-progetti pr-3 pb-1 ">

                    {#await elencoProgetti() then result}

                        {#if result.result.length > 0}

                            <Subheader>
                                Progetti
                            </Subheader>

                            <!-- Elenco -->
                            <div class="d-flex flex-wrap align-content-start pl-3">

                                {#if progettoSelected && !result.result.includes(progettoSelected)}
                                
                                    <Chip 
                                        link
                                        class="mr-2 mb-2 green white-text" 
                                        on:click={() => {
                                            progettoSelected = null;
                                        }}
                                    >
                                        {progettoSelected}
                                    </Chip>
    
                                {/if}
    
                                {#each result.result as progetto}
    
                                    {@const isSelected = progetto === progettoSelected}
                                
                                    <Chip 
                                        link
                                        outlined={!isSelected} 
                                        class="mr-2 mb-2 {isSelected ? "green white-text" : "green-text"}" 
                                        on:click={() => {
                                            progettoSelected = isSelected ? null : progetto;
                                        }}
                                    >
                                        {progetto}
                                    </Chip>
    
                                {/each}
    
                                {#if result.pagine_totali > 1}
    
                                    <Chip 
                                        link
                                        outlined
                                        class="green-text" 
                                        on:click={() => showPopupProgetti = true} 
                                    >
                                        Altri progetti
                                        <Icon path={mdiDotsHorizontalCircle} />
                                    </Chip>
    
                                {/if}
    
                            </div>
                            
                        {/if}

                    {/await}

                </div>

                <Subheader>
                    Provette
                </Subheader>

                <!-- Elenco provette principale -->
                {#await elencoProvette(progettoSelected, statusSelected)}

                    <div class="d-flex align-center justify-center pa-3">
                        <ProgressCircular indeterminate color="green" />
                    </div>
                    
                {:then result}

                    {#if result.length > 0}
                    
                        <List style="width: 100%">
                        
                            {#each elenco_provette as p}
                                <ListItem on:click={() => id_provetta = p.id_provetta}>
                                    {p.id_provetta}
                                    <span slot="subtitle">
                                        {p?.progetto}
                                    </span>
                                    <div slot="append">
                                        <Chip class={getStateColor(p.stato)}>
                                            {p.stato}
                                        </Chip>
                                    </div>
                                </ListItem>
                            {/each}

                            {#if isDownloadingList}

                                <ListItem class="d-flex align-center justify-center">
                                    <ProgressCircular indeterminate color="green" />
                                </ListItem>    
                            
                            {/if}
        
                        </List>

                    {:else}

                        <div class="text-center">
                            Non ci sono provette
                        </div>

                    {/if}
                
                {:catch e}

                    <div class="text-center">
                        {e}
                    </div>
                    
                {/await}

            </div>
        </div>

    {/if}

    <!-- Login popup -->
    <Dialog persistent active={!user} width={600} class="pa-6">

        {#if stateLogin === "loading"}

            <div class="pt-16 pb-16 d-flex align-center justify-center">

                <ProgressCircular size={64} indeterminate color="green" />

            </div>
        
        {:else if stateLogin === "login"}

            <h4 class="mb-9 font-weight-black">
                Area riservata
            </h4>

            <TextField filled color="green" rules={emailRules} bind:value={email}>
                Email
            </TextField>

            <TextField class="mt-1" color="green" filled rules={passwordRules} type={showPassword ? 'text' : 'password'} bind:value={password}>
                Password
                <div slot="append" on:click={() => showPassword = !showPassword}>
                    <Icon path={showPassword ? mdiEyeOff : mdiEye} />
                </div>
            </TextField>

            <Button class="green white-text mt-3" block depressed on:click={login}>
                Entra
            </Button>

            <Button class="green-text mt-1" block depressed outlined on:click={() => dispatch("close")}>
                Torna indietro
            </Button>

        {:else}

            <h5 class="text-h5">
                {stateLogin}
            </h5>

            <Button class="green white-text mt-3" block depressed on:click={() => {
                stateLogin = "login";
                password = "";
            }}>
                Torna al login
            </Button>

            <Button class="green-text mt-1" block depressed outlined on:click={() => dispatch("close")}>
                Torna indietro
            </Button>

        {/if}

    </Dialog>

    <!-- Provetta popup -->
    <Dialog active={id_provetta} fullscreen class="white" on:outroend={resetVariables}>
        
        <div style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; overflow-y:auto" on:scroll={showShadowPage}>

            <AppBar class="white" flat={shadowPageFlat} style="position: sticky; top: 0">
                <div slot="icon">
                    <Button icon depressed on:click={() => id_provetta = null}>
                      <Icon path={mdiClose} />
                    </Button>
                  </div>
                  <span slot="title">{id_provetta}</span>
                  <!-- <span style="flex-grow: 1;"></span>
                  <Button icon on:click={copyProvetta}>
                      <Icon path={mdiContentCopy} />
                  </Button> -->
            </AppBar>
    
            <div class="pa-3">
    
                {#await informazioniProvetta(id_provetta, updatePage)}
    
                    <div class="d-flex align-center justify-center pa-3">
                        <ProgressCircular indeterminate color="green" />
                    </div>
                    
                {:then result}
    
                    <Row noGutters>
    
                        {#if !dataProvetta.hasOwnProperty("apertura")}
                            <Col cols={12} class="pa-1">
                                <div class="d-flex align-center justify-center pa-3">
                                    La provetta non risulta aperta
                                </div>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("email")}
                            <Col cols={12} sm={12} md={6} lg={6} xl={3} class="pa-1">
                                <TextField value={dataProvetta?.email} readonly color="green" filled>
                                    Email
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("notifiche_push")}
                            <Col cols={12} sm={12} md={6}  lg={6} xl={3} class="pa-1">
                                <TextField value={dataProvetta?.notifiche_push ? "Abilitate" : "Disabilitate"} readonly color="green" filled>
                                    Notifiche push
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("apertura")}
                            <Col cols={12} sm={12} md={6} lg={6} xl={3} class="pa-1">
                                <TextField value={getDateString(dataProvetta?.apertura)} readonly color="green" filled>
                                    Data apertura
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("chiusura")}
                            <Col cols={12} sm={12} md={6} lg={6} xl={3} class="pa-1">
                                <TextField value={getDateString(dataProvetta?.chiusura)} readonly color="green" filled>
                                    Data chiusura
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("posizione")}
                            <Col cols={12} sm={12} md={6} lg={6} xl={3} class="pa-1">
                                <TextField value={JSON.parse(dataProvetta.posizione).lat} readonly color="green" filled>
                                    Latitudine
                                </TextField>
                            </Col>
                            <Col cols={12} sm={12} md={6}  lg={6} xl={3} class="pa-1">
                                <TextField value={JSON.parse(dataProvetta.posizione).lng} readonly color="green" filled>
                                    Longitudine
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("altitudine")}
                            <Col cols={12} sm={12} md={6} lg={6} xl={3} class="pa-1">
                                <TextField value={dataProvetta?.altitudine + " m"} readonly color="green" filled>
                                    Altitudine
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("tempo_apertura")}
                            <Col cols={12} sm={12} md={6}  lg={6} xl={3} class="pa-1">
                                <TextField value={dataProvetta?.tempo_apertura + ""} readonly color="green" filled>
                                    Tempo di apertura (ore)
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("progetto")}
                            <Col cols={12} class="pa-1">
                                <TextField value={dataProvetta?.progetto} readonly color="green" filled>
                                    Progetto
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("stato")}
                            <Col cols={12} class="pa-1">
                                <TextField value={dataProvetta?.stato} readonly color="green" filled>
                                    Stato
                                </TextField>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("posizione")}
                            <Col cols={12} class="pa-1">
                                {#await getAddress(dataProvetta.posizione)}
    
                                    <TextField value={"Caricamento in corso..."} readonly color="green" filled>
                                        Indirizzo
                                    </TextField>
    
                                {:then result} 
                                    
                                    <TextField value={result} readonly color="green" filled>
                                        Indirizzo
                                    </TextField>
                                
                                {/await}
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("note")}
                            <Col cols={12} class="pa-1">
                                <Textarea value={dataProvetta?.note} readonly color="green" filled>
                                    Note
                                </Textarea>
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("concentrazione")}
                            <Col cols={12} class="pa-1">
    
                                <DataTable>
    
                                    <DataTableHead>
    
                                        <DataTableRow>
                                            <DataTableCell>Inquinante</DataTableCell>
                                            <DataTableCell numeric>Valore</DataTableCell>
                                            <DataTableCell numeric></DataTableCell>
                                        </DataTableRow>
    
                                    </DataTableHead>
    
                                    <DataTableBody>
    
                                        {#each Object.keys(dataProvetta.concentrazione) as k, i}
    
                                            <DataTableRow>
                                                <DataTableCell>
                                                    {k}
                                                </DataTableCell>
                                                <DataTableCell numeric>
                                                    {dataProvetta.concentrazione[k]}
                                                </DataTableCell>
                                                <DataTableCell numeric>
                                                    <Button icon depressed class="white" on:click={() => {
                                                        addConcentrazione = true;
                                                        tipologiaAdd = "custom";
                                                        inquinante = k;
                                                        value = dataProvetta.concentrazione[k];
                                                    }}>
                                                        <Icon class="black-text" path={mdiPencil} />
                                                    </Button>
                                                    <Button icon depressed class="white" on:click={() => {
                                                        deleteCoefficiente(k);
                                                    }}>
                                                        <Icon class="red-text" path={mdiDelete} />
                                                    </Button>
                                                </DataTableCell>
                                            </DataTableRow>
    
                                        {/each}                                    
    
                                    </DataTableBody>
    
                                </DataTable>
                                
                            </Col>
                        {/if}
    
                        {#if dataProvetta.hasOwnProperty("tempo_apertura") && dataProvetta.tempo_apertura > 0}
                            <Col cols={12} class="pa-1">
                                <Button block depressed class="green white-text" on:click={() => addConcentrazione = true}>
                                    Aggiungi concentrazione
                                </Button>
                            </Col>
                        {/if}
    
                        {#if dataProvetta?.stato === "Analizzata"}
                            <Col cols={12} class="pl-1 pr-1 pb-1">
                                <Button block depressed class="teal white-text" on:click={() => programmaNotifica(dataProvetta?.id_provetta)}>
                                    Programma notifica
                                    <Icon path={mdiSend} class="ml-3" />
                                </Button>
                            </Col>
                        {/if}
    
                    </Row>
    
                {:catch e}
    
                    <div class="text-center pa-3">
                        {e}
                    </div>
                    
                {/await}
    
            </div>
    
            <Overlay bind:active={addConcentrazione}>
    
                <div style="width: 97vw; max-width: 600px; max-height: 95vh; overflow-y: auto" class="white pa-3 elevation-1 rounded" use:ClickOutside on:clickOutside={() => {
                    if(!showCurvaCreator)
                        resetVariablesAddConcentrazione();
                }}>
                    
                    <Select mandatory class="green-text" bind:value={tipologiaAdd} items={tipologiaAdds} filled on:change={() => {
                        inquinante = null;
                        value = "";
                        curva = null;
                        curve = [];
                        assorbanza = "";
                        volumeFinale = "";
                        volumePrelievo = "";
                        valueK = "";
                        volumeEstrazione = "";
                        concentrazioneInCuvetta = "";
                    }}>
                        Metodo
                    </Select>  
                    
                    {#if tipologiaAdd === "custom"}
    
                        <Select mandatory class="green-text" bind:value={inquinante} items={allInquinanti} filled>
                            Inquinante
                        </Select>  
    
                        <TextField filled type="number" color="green" bind:value={value}>
                            Valore
                        </TextField>
    
                        <Button block depressed class="green white-text" disabled={!inquinante || !value} on:click={() => applyConcentrazione(value)}>
                            {dataProvetta.hasOwnProperty("concentrazione") && dataProvetta.concentrazione.hasOwnProperty(inquinante) ? "Modifica" : "Aggiungi"}
                        </Button>
                    
                    {:else}
    
                        <Select mandatory class="green-text" bind:value={inquinante} items={guidedInquinanti} filled>
                            Inquinante
                        </Select>  
    
                        {#if inquinante}
    
                            <div class="d-flex flex-row">
    
                                <div style="flex: 1">
                                    {#await elencoCurve(inquinante, dataProvetta?.progetto)}
                                        <Select disabled class="green-text" filled bind:value={curva} items={curve}>
                                            Curva di calibrazione
                                        </Select>  
                                    {:then result} 
                                        <Select class="green-text" filled bind:value={curva} items={curve} mandatory>
                                            Curva di calibrazione
                                        </Select>  
                                    {:catch e}
                                        <Select disabled class="green-text" filled bind:value={curva} items={curve}>
                                            Curva di calibrazione
                                        </Select>  
                                    {/await}
                                </div>
    
                                <div style="flex: 0" class="d-flex justify-center align-center pl-2 pr-2" on:click={() => showCurvaCreator = true}>
                                    <Button depressed size="small" fab class="green">
                                        <Icon path={mdiPlus} class="white-text" />
                                    </Button>
                                </div>
    
                            </div>
                        
                        {:else}
    
                            <div class="d-flex flex-row">
    
                                <div style="flex: 1">
                                    <Select disabled class="green-text" filled>
                                        Curva di calibrazione
                                    </Select>  
                                </div>
    
                                <div style="flex: 0" class="d-flex justify-center align-center pl-2 pr-2">
                                    <Button disabled depressed size="small" fab class="green">
                                        <Icon path={mdiPlus} class="white-text" />
                                    </Button>
                                </div>
    
                            </div>
    
                        {/if}
    
                        <Button block depressed outlined class="green-text" disabled={!curva} on:click={() => showCurvaCreator = curva}>
                            Modifica curva
                            <Icon class="ml-3" size="18" path={mdiPencil} />
                        </Button>
    
                        <TextField filled color="green" disabled={!curva} bind:value={assorbanza}>
                            Assorbanza
                        </TextField>
    
                        {#if curva && assorbanza}
                        
                            {#await getConcentrazioneInCuvetta(assorbanza, dataProvetta?.progetto)}
    
                                <TextField readonly filled color="green" value={"..."}>
                                    Concentrazione in cuvetta
                                </TextField>
                                
                            {:then result} 
    
                                <TextField readonly filled color="green" value={concentrazioneInCuvetta}>
                                    Concentrazione in cuvetta
                                </TextField>
    
                            {:catch e}
                            
                                <TextField readonly filled color="green" value={"Errore"}>
                                    Concentrazione in cuvetta
                                </TextField>
    
                            {/await}
    
                        {:else}
    
                            <TextField readonly filled color="green" value={"..."}>
                                Concentrazione in cuvetta
                            </TextField>
    
                        {/if}
    
                        <TextField filled color="green" disabled={!concentrazioneInCuvetta} bind:value={volumeFinale}>
                            Volume finale
                        </TextField>
    
                        <TextField filled color="green" disabled={!concentrazioneInCuvetta} bind:value={volumePrelievo}>
                            Volume prelievo
                        </TextField>
    
                        <TextField readonly filled color="green" value={getOutputIntermedio(concentrazioneInCuvetta, volumeFinale, volumePrelievo)}>
                            Output intermedio
                        </TextField>
    
                        <TextField filled color="green" disabled={!concentrazioneInCuvetta || !volumeFinale || !volumePrelievo} bind:value={volumeEstrazione}>
                            Volume estrazione
                        </TextField>
    
                        <TextField readonly filled color="green" value={getOutputInUg(volumeEstrazione, concentrazioneInCuvetta, volumeFinale, volumePrelievo)}>
                            Output in ug
                        </TextField>
    
                        <TextField filled color="green" disabled={!concentrazioneInCuvetta || !volumeFinale || !volumePrelievo || !volumeEstrazione} bind:value={valueK}>
                            K
                        </TextField>
    
                        <TextField readonly filled color="green" value={getConcentrazioneInAria(valueK, volumeEstrazione, concentrazioneInCuvetta, volumeFinale, volumePrelievo)}>
                            Concentrazione in aria
                        </TextField>
    
                        <Button block depressed class="green white-text" disabled={!inquinante || !valueK} on:click={() => {
                            applyConcentrazione(getConcentrazioneInAria(valueK, volumeEstrazione, concentrazioneInCuvetta, volumeFinale, volumePrelievo));
                        }}>
                            {dataProvetta.hasOwnProperty("concentrazione") && dataProvetta.concentrazione.hasOwnProperty(inquinante) ? "Modifica" : "Aggiungi"}
                        </Button>
    
                    {/if}
    
                    <Button block outlined depressed class="red-text" on:click={resetVariablesAddConcentrazione}>
                        Chiudi
                    </Button>
    
                </div>
                
            </Overlay>
    
            <Dialog bind:active={showCurvaCreator} class="white" on:outroend={resetVariablesCurvaCreator}>
    
                <AppBar class="white" flat>
                    <span slot="icon">
                        <Button icon on:click={() => {
                            showCurvaCreator = false;
                        }}>
                            <Icon path={mdiClose} />
                        </Button>
                    </span>
                    <span slot="title">
                        {typeof(showCurvaCreator) === "string" ? "Modifica curva" : "Crea curva"}
                    </span>
                    <span style="flex-grow: 1;"></span>
                    <Button depressed class="green-text" text size="small" on:click={() => saveCurva(dataProvetta?.progetto)}>
                        Salva
                        <Icon class="ml-3" size="16" path={mdiFloppy} />
                    </Button>
                </AppBar>
    
                <div class="creator-curve pa-2">
    
                    {#if typeof(showCurvaCreator) === "string"}
                    
                        <TextField filled readonly color="green" value={showCurvaCreator}>
                            Nome curva
                        </TextField>
    
                    {:else}
    
                        <TextField filled color="green" bind:value={newCurvaName} on:change={updateCurva}>
                            Nome curva
                        </TextField>
    
                    {/if}
    
                    {#if typeof(showCurvaCreator) === "string"}
                        <Button depressed block class="red-text" outlined size="small" on:click={deleteCurva}>
                            Cancella 
                            <Icon class="ml-3" size="16" path={mdiDelete} />
                        </Button>
                    {/if}
    
                    <div class="table-points">
    
                        
                        <div class="row">
    
                            <div class="col text-center font-weight-black">
                                X
                            </div>
    
                            <div class="col text-center font-weight-black">
                                Y
                            </div>
    
                            <div class="action">
    
                            </div>
    
                        </div>
                        
                        {#await getPunti(dataProvetta?.progetto)}
    
                            <div class="d-flex align-center justify-center pa-3">
                                <ProgressCircular indeterminate color="green" />
                            </div>
                            
                        {:then res} 
                        
                            {#each punti as p, i}
    
                                <div class="row">
    
                                    <div class="col">
                                        <input class="curva-input" type="number" bind:value={p[0]} on:input={updateCurva} />
                                    </div>
    
                                    <div class="col">
                                        <input class="curva-input" type="number" bind:value={p[1]} on:input={updateCurva} />
                                    </div>
    
                                    <div class="action">
                                        {#if i !== punti.length-1}
                                            <Button icon depressed on:click={() => {
                                                punti.splice(i, 1);
                                                punti = punti;
                                                updateCurva();
                                            }}>
                                                <Icon class="red-text" path={mdiDelete} />
                                            </Button>
                                        {/if}
                                    </div>
    
                                </div>
    
                            {/each}   
    
                        {/await}
    
                    </div>         
    
                </div>
    
            </Dialog>
    

        </div>

    </Dialog>


    <!-- Scan page -->
    <Dialog bind:active={showScan} fullscreen class="black" on:introend={startCamera} on:outroend={stopCamera}>
        <div class="scan-page">
            <div class="action-bar">
                <AppBar class="black" flat>
                    <div slot="icon">
                        <Button class="white-text" icon depressed on:click={() => showScan = false}>
                          <Icon path={mdiClose} />
                        </Button>
                      </div>
                      <span slot="title" class="white-text">Scan</span>
                </AppBar>
            </div>
            <div class="scan-area">
                {#if !showErrorBox}
                    <div id="scan-area-admin"></div>
                {:else}
                    <span class="white-text text-center">
                        Per utilizzare questa funzionalità bisogna abilitare i permessi per la fotocamera
                    </span>
                {/if}
            </div>
        </div>
    </Dialog>

    <!-- Elenco progetti completo -->
    <Dialog bind:active={showPopupProgetti} class="pa-3" on:introstart={() => queryProgetto = ""}>
        <div class="d-flex flex-column" style="height: 400px;">

            <div>
                <TextField filled color="green" bind:value={queryProgetto}>
                    Cerca progetto
                </TextField>
            </div>
    
            <!-- Elenco -->
            <div style="flex: 1; overflow-y: auto" class="d-flex flex-wrap align-content-start pt-3">
                {#await elencoProgetti(queryProgetto, 100) then result}
        
                        {#if progettoSelected && !result.result.includes(progettoSelected)}
                        
                            <Chip 
                                link
                                class="mr-2 mb-2 green white-text" 
                                on:click={() => {
                                    progettoSelected = null;
                                }}
                            >
                                {progettoSelected}
                            </Chip>
        
                        {/if}
        
                        {#each result.result as progetto}
        
                            {@const isSelected = progetto === progettoSelected}
                        
                            <Chip 
                                link
                                outlined={!isSelected} 
                                class="mr-2 mb-2 {isSelected ? "green white-text" : "green-text"}" 
                                on:click={() => {
                                    progettoSelected = isSelected ? null : progetto;
                                }}
                            >
                                {progetto}
                            </Chip>
        
                        {/each}
                        
                {/await}
            </div>

            <div>
                <Button block outlined class="red-text" on:click={() => showPopupProgetti = false}>
                    Chiudi
                </Button>
            </div>

        </div>
    </Dialog>

    <Snackbar class="flex-column" bind:active={snackbarActive} bottom center timeout={3000}>
        {snackbarMessage}
    </Snackbar>

</main>

<style>

    main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .content-admin {
        flex: 1;
        overflow: hidden;
    }

    .content-admin > .content {
        width: 97%;
        max-width: 1000px;
        height: 99%;
        overflow-y: auto;
    }

    .content-admin > .content > .search-bar {
        position: sticky;
        top: 0;
        width: 100%;
        height: auto;
        z-index: 1;
        transition: 0.5s ease background;
    }

    .scan-page {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .scan-page > .action-bar {
        flex: 0;
    }

    .scan-page > .scan-area {
        flex: 1;
        display: grid;
        place-items: center;
    }

    .scan-page > .scan-area > div {
        width: 100%;
        height: auto;
    }

    .creator-curve {
        height: 300px;
        overflow-y: auto;
    }

    .curva-input {
        height: 100%;
        margin: 0;
        outline: 0;
    }

    .table-points {
        width: 100%;
        height: auto;
    }

    .table-points > .row {
        width: 100%;
        height: 48px;
        display: flex;
        flex-direction: row;
    }

    .table-points > .row > .col {
        flex: 5;
        display: grid;
        place-items: center;
        border: 0.5px solid #bdbdbd;
    }

    .table-points > .row > .col > input {
        width: 100%;
        height: 100%;
    }

    .table-points > .row > .action {
        flex: 1;
        display: grid;
        place-items: center;
    }

    :global(.s-tbl) {
        width: 100%;
    }

    :global(.s-tbl > table) {
        width: 100%;
    }

    /* :global(.s-tbl > table tr:first-child) {
        width: 16px !important;
    } */

</style>

